import showAlert from "../server/ShowAlert";
import * as actionType from "./action";

const initialState = {
  productsInCart: [],
  productSale: [],
  orderSum: 0,
  totalSum: 0,
  orderTime: null,
  refresh: false,
  deliveryPrice: null,
  deliveryAvailable: false,
  minOrder: 250,
};

const calculateSum = (cartItems) => {
  const validProducts = cartItems.filter(
    (p) => p.totalPrice != null && p.quantity != null
  );
  let orderSum = (
    parseFloat(validProducts.reduce((prev, x) => prev + +x.totalPrice, 0)) || 0
  ).toFixed(2);
  console.log("##orderSum", orderSum);
  return { orderSum };
};

const handleUpsertProduct = (state, payload) => {
  const { quantity, data, productId, promoId } = payload;
  console.log("ifHaveToSHowError called with:", productId, quantity, data);
  let productsInCart = [...state.productsInCart];
  let refresh = false;
  if (data.status === 409 || data.status === "409") {
    let msg = "המוצר לא במלאי";
    const productInCart = productsInCart.find(
      (product) => product.productId === productId
    );
    if (productInCart) {
      msg = `מצטערים, יש במלאי ${productInCart.quantity} יחידות `;
      const index = productsInCart.findIndex(
        (product) => product.productId === productId
      );
      productsInCart[index] = {
        ...productInCart,
        warningMessage: msg,
      };
    }
    showAlert({ msgTitle: msg, msgTimer: 3000 });
    refresh = true;
    return { productsInCart, refresh };
  }

  if (data.status === "deleted") {
    console.log("ifHaveToSHowError sees deleted product:", data.reservedItem);
    productsInCart = productsInCart.filter(
      (product) => product.productId !== productId
    );
    return { productsInCart, refresh };
  }

  //לשנות מוצר לעגלה
  else {
    const index = productsInCart.findIndex(
      (product) => product.productId === data.reservedItem.productId
    );

    let warningMessage = "";
    if (data.promoUsageLimited) {
      warningMessage =
        "כמות המימושים המקסימלית לקניה למבצע כבר נאספה, כעת יתווסף המוצר במחירו הרגיל";
    }

    if (data.reservedItem.quantity === 0) {
      // מחיקה מהעגלה
      if (index >= 0) {
        productsInCart.splice(index, 1);
      }
    } else if (index >= 0) {
      productsInCart[index] = {
        cartId: data.cartId,
        productId: data.reservedItem.productId,
        product: data.reservedItem.product,
        quantity: data.reservedItem.quantity,
        totalPrice: data.reservedItem.totalPrice,
        unitPrice: data.reservedItem.unitPrice,
        promoId: data.reservedItem.promoId,
      };
      if (warningMessage) {
        productsInCart[index].warningMessage = warningMessage;
      }
    }
    //להוסיף לעגלה
    else {
      productsInCart.push({
        cartId: data.cartId,
        productId: data.reservedItem.productId,
        product: data.reservedItem.product,
        quantity: data.reservedItem.quantity,
        totalPrice: data.reservedItem.totalPrice,
        unitPrice: data.reservedItem.unitPrice,
        promoId: data.reservedItem.promoId,
        warningMessage: warningMessage ?? "",
      });
    }
  }

  if (data.reservedItem.isPriceChanged) {
    showAlert({
      msgTitle: `המחיר למוצר השתנה כעת ל ${parseFloat(
        data.reservedItem.priceChangedItem.unitPricenitPrice
      ).toFixed(2)}`,
      msgTimer: 3000,
    });
  }
  if (data.reservedItem.promoId && !promoId) {
    showAlert({ msgTitle: "מבצע חדש", msgTimer: 3000 });
  }
  return { productsInCart, refresh };
};

const handleRevalidationItems = (productsInCart, data) => {
  let msg = "";
  console.log("in handle revalidation");

  productsInCart = productsInCart.map((product) => {
    console.log("pay", data);
    const revalidatedItem = data.revalidatedItems[product.productId];
    console.log("reva", revalidatedItem);

    if (!revalidatedItem) return product; // no change for this product

    if (revalidatedItem.isPriceChanged) {
      msg += `המחיר למוצר ${product.product.name} השתנה ל ${revalidatedItem.totalPrice}`;
      if (!data.promoUsageLimited && product.warningMessage) {
        product.warningMessage = "";
      }
      return {
        ...product,
        totalPrice: revalidatedItem.totalPrice,
        unitPrice: revalidatedItem.unitPrice,
      };
    }
  });
  showAlert({ msgTitle: "שים לב", msgText: msg, msgTimer: 3000 });
  return productsInCart;
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.ADD_PRODUCT_IN_CART:
      console.log("@@ADD_PRODUCT_IN_CART", action.payload);
      const data = handleUpsertProduct(state, action.payload);
      const sum = calculateSum(data.productsInCart || []);
      console.log("@@ADD_PRODUCT_IN_CART22", sum);
      return {
        ...state,
        productsInCart: [...data.productsInCart],
        orderSum: sum.orderSum,
        deliveryPrice: state.deliveryPrice,
        deliveryAvailable: state.deliveryAvailable,
        refresh: true,
      };
    case actionType.SET_REVALIDATED_PRODUCTS: {
      console.log("@@SET_REVALIDATED_PRODUCTS", action.payload, state);
      const data = handleUpsertProduct(state, action.payload);
      const sum = calculateSum(data.productsInCart || []);
      const productsInCart = handleRevalidationItems(
        data.productsInCart,
        action.payload.data
      );
      return {
        ...state,
        productsInCart,
        orderSum: sum.orderSum,
        deliveryPrice: state.deliveryPrice,
        deliveryAvailable: state.deliveryAvailable,
        refresh: true,
      };
    }
    case actionType.SET_ALL_PRODUCT: {
      const sumSet = calculateSum(action.payload.cart.items || []);
      const outOfStockItems = action.payload.missingQuantities || null;
      if (outOfStockItems) {
        const msg =
          "שימו 💥 לב: חלק מהמוצרים אזלו מהמלאי או שהכמויות השתנו, כיוון שהעגלה נשארה פתוחה זמן רב. מומלץ לבדוק מחדש את העגלה לפני השלמת ההזמנה.";
        showAlert({ msgTitle: msg, msgTimer: 3000 });
      }

      return {
        ...state,
        orderSum: sumSet.orderSum,
        productsInCart: action.payload.cart.items || [],
        orderTime: action.payload.OrderTime,
        deliveryPrice: state.deliveryPrice,
        deliveryAvailable: state.deliveryAvailable,
      };
    }

    case actionType.CLEAR_CARD:
      return {
        ...state,
        productsInCart: [],
        productSale: [],
        totalSum: 0,
        orderSum: 0,
        orderTime: null,
      };
    case actionType.CANCEL_ERROR:
      return {
        ...state,
      };

    case actionType.SET_ORDER_TIME:
      return {
        ...state,
        orderTime: action.payload,
      };
    case actionType.SET_PRODUCTS:
      return {
        ...state,
        refresh: false,
      };
    case actionType.SET_DELIVERY_PRICE:
      if (action.payload.deliveryAvailable)
        return {
          ...state,
          deliveryPrice: action.payload.deliveryPrice,
          deliveryAvailable: true,
        };
      else
        return {
          ...state,
          deliveryPrice: action.payload.deliveryPrice,
          deliveryAvailable: false,
        };
    case actionType.SET_MIN_ORDER:
      return {
        ...state,
        minOrder: action.payload,
      };
    case actionType.SET_ORDER_FOR_FREE:
      return {
        ...state,
        orderForFree: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
